export const NAVBAR_ROUTES = [
  {
    path: "/",
    name: "Inicio",
  },
  {
    path: "/category/Zapatillas",
    name: "Zapatillas",
  },
  {
    path: "/category/Camisetas",
    name: "Camisetas",
  },
  {
    path: "/category/Shorts",
    name: "Shorts",
  },
];
